export default {
  ADULTS_HOST: process.env.ADULTS_HOST,
  CHILD_HOST: process.env.CHILD_HOST,
  INVENTORY_HOST: process.env.INVENTORY_HOST,
  SITE: process.env.SITE,
  SITE_ID: process.env.SITE_ID,
  EVENTS_HOST: process.env.EVENTS_HOST,
  LOCALHOST: process.env.LOCALHOST,
};
